/**
 * Ordena los grupos evento/sesión de una reserva por cercanía: primero las
 * sesiones de hoy en adelante, de la más próxima a la más lejana, y al final
 * las ya pasadas (la más reciente primero).
 * `session.start_date` llega en hora de pared marcada como UTC, así que "hoy"
 * se calcula igual: medianoche de Madrid leída como UTC.
 */
export function sortGroupsByNearestSession<T extends { session: any }>(groups: T[]): T[] {
  const madridToday = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Madrid' }).format(new Date());
  const today = Date.parse(`${madridToday}T00:00:00Z`);
  const time = (group: T): number => {
    const parsed = Date.parse(group.session?.start_date);
    return isNaN(parsed) ? Infinity : parsed;
  };

  return groups.sort((a, b) => {
    const timeA = time(a);
    const timeB = time(b);
    const pastA = timeA < today;
    const pastB = timeB < today;
    if (pastA !== pastB) return pastA ? 1 : -1;
    if (timeA === timeB) return 0;
    return pastA ? timeB - timeA : timeA - timeB;
  });
}
